import React from "react";
//outsource
import { Row, Col, Space, DatePicker, Button } from "antd";
import moment from "moment";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

//components

//redux
import { useDispatch } from "react-redux";
import { unLockRoster } from "../../../store/roster/roster.action";
import { LEVELS } from "../../../store/string";
dayjs.extend(customParseFormat);

const { RangePicker } = DatePicker;
const weekFormat = "ddd DD/MM";
const startOfString = "week";

const RosterTopBar = ({
  handleWeekChange,
  copyRosterLastWeek,
  loading,
  filledUp,
  lock,
  copying,
  from,
  to,
}) => {
  // -------------------------- VAR --------------------------
  const customWeekStartEndFormat = (value) =>
    `${value.startOf(startOfString).format(weekFormat)} - ${value
      .endOf(startOfString)
      .format(weekFormat)}`;
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const renderColorRanges = () => {
    const colorRange = LEVELS?.map((item, index) => {
      return (
        <Col key={index}>
          <Button
            style={{
              backgroundColor: item?.color,
              borderRadius: 12,
              width: 80,
              height: "100%",
            }}
            size="small"
          >
            {item?.name}
          </Button>
        </Col>
      );
    });
    return <Row gutter={[5, 5]}>{colorRange}</Row>;
  };
  const renderUpdateRoster = () => {
    const today = moment().startOf('day');
    const hiden = today > to;
    if (!hiden) {
      return (
        <Col align="right" xl={4} lg={4} md={24} xs={24}>
          <Button
            disabled={!lock || copying}
            type="primary"
            onClick={() => {
              dispatch(unLockRoster({ lock }));
            }}
            loading={loading}
          >
            UPDATE ROSTER
          </Button>
        </Col>
      );
    }
    return null;
  };
  // -------------------------- MAIN --------------------------
  return (
    <Row justify="space-between">
      <Col xl={20} lg={20} md={24} xs={24}>
        <Row span={24}>
          <Space>
            <DatePicker
              format={customWeekStartEndFormat}
              picker="week"
              onSelect={handleWeekChange}
              defaultValue={moment()}
              allowClear={false}
              disabled={copying} // disabled khi dang copy roster
            />
            <Button loading={copying} onClick={copyRosterLastWeek}>
              COPY FROM PREVIOUS WEEK
            </Button>
            {renderColorRanges()}
          </Space>
        </Row>
      </Col>
      {renderUpdateRoster()}
    </Row>
  );
};

export default RosterTopBar;
